import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'

// ------------------------------------
// Constants
// ------------------------------------
export const PLATFORM_PAYBY_FAQS_DETAIL = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
}, 'PLATFORM_PAYBY_FAQS_DETAIL')

// ------------------------------------
// Actions
// ------------------------------------
export function init() {
  return (dispatch) => {
    dispatch(callAPI({
      dispatch: dispatch,
      endpoint: 'test.json',
      requestAction: PLATFORM_PAYBY_FAQS_DETAIL.INIT_REQUEST,
      successAction: PLATFORM_PAYBY_FAQS_DETAIL.INIT_SUCCESS,
      success: function(result) {}
    }))
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [PLATFORM_PAYBY_FAQS_DETAIL.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [PLATFORM_PAYBY_FAQS_DETAIL.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'platformPayByFaQsDetail',
    reducerMap: {
      platformPayByFaQsDetailState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
